export default "__VITE_ASSET__Dd61p_4c__"